module.exports = __webpack_public_path__ + "img/circle@2x.974502de.png";